import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const NetworkError = ({ onClose }) => {
  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='Oh dear'
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          Looks like you are not connected to the internet. Please make sure you
          have internet access and try again.
        </Text>
      }
      buttons={
        <Button onClick={onClose} variant='primary-inverted' text='Dismiss' />
      }
    />
  )
}
